import React, { useState, useRef, useEffect, useCallback } from "react";
import TransferInvoiceListModal from "../salesReturn/TransferInvoiceListModal";
import {
  Save,
  Search,
  User,
  Phone,
  Trash2,
  ArrowRight,
  FileText,
} from "lucide-react";
import Modal from "../common/CommonModal";
import axios from "axios";
import ProductListing from "../salesInvoice/ProductsModal";
import useApi from "../../hooks/useApi";
import CreditCustomerList from "../common/CreditCustomerList";
import { useLocation, useNavigate } from "react-router-dom";

const WarrantyClaim = () => {
  const COMPANY_CODE = localStorage?.getItem("companyCode") || "DOODDEMO";
  const DEPARTMENT =
    localStorage.getItem("currentSelectedDepartment") || "MAIN";
  const API_PATHS = localStorage.getItem("apiPaths")
    ? JSON.parse(localStorage.getItem("apiPaths"))
    : "-";
  const BASE_URL = API_PATHS[0]?.API_CONFIG || "https://cubixweberp.com:213";
  const CURRENT_USER_OBJECT = localStorage.getItem("currentUser")
    ? JSON.parse(localStorage.getItem("currentUser"))
    : "";
  const VATPERCENTAGE = CURRENT_USER_OBJECT[0]?.vatp;
  const [claimNo, setClaimNo] = useState("");
  const [isLocal, setIsLocal] = useState(true);
  const [customer, setCustomer] = useState(null);
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);
  const [invoice, setInvoice] = useState(null);
  const [departmentList, setDepartmentList] = useState([]);
  const [glSettings, setGlSettings] = useState({});
  const [selectedDept, setSelectedDept] = useState(DEPARTMENT);
  const [items, setItems] = useState([]);
  const [showStockList, setShowStockList] = useState(false);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchBy, setSearchBy] = useState("UNIVERSAL");
  const { request } = useApi();
  const invoiceInputRef = useRef();
  const [activeRowIndex, setActiveRowIndex] = useState(null);
  const [showCustomerList, setShowCustomerList] = useState(false);
  const [vatPercent, setVatPercent] = useState(VATPERCENTAGE || 5);
  const [remarks, setRemarks] = useState("");

  const mode = useLocation()?.state?.mode || "SAVE";
  const documentNoFromState = useLocation()?.state?.docNo || "";
  const isEditMode = mode === "edit";
  const isViewMode = mode === "view";
  const navigate = useNavigate();
  // F2 key handler
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (
        document.activeElement === invoiceInputRef.current &&
        e.key === "F2"
      ) {
        e.preventDefault();
        setShowInvoiceModal(true);
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  const handleInvoiceSelect = (inv, transferredItems) => {
    setInvoice(inv);
    console.log("transferredItems in handleInvoiceSelect", transferredItems);
    if (transferredItems && transferredItems.length > 0) {
      const firstItem = transferredItems[0];

      // 1. Set Customer Info (Account & Name)
      setCustomer({
        account: firstItem.cust_acc,
        name: firstItem.custref?.trim(),
        phone: firstItem.tel || firstItem.phone,
        invDate: firstItem.inv_date
          ? new Date(firstItem.inv_date).toLocaleDateString()
          : "-",
      });

      // 2. Map Transferred Items to Table structure
      const mappedItems = transferredItems.map((item) => ({
        code: item.code,
        description: item.idesc,
        qty: item.tr_qty || 1,
        maxQty: item.tr_qty || 1,
        replCode: "",
        replSerial: "",
        c1: "",
        c2: "",
        rcvdSerial: "",
        supplierAcc: "",
        supplier: "",
        rtnPrice: item.unit_price || 0,
        // itSlNo: item.it_slno,
        // gid: item.soGuid || "",
        rplPrice: 0,
      }));

      setItems((prev) => {
        const appended = [...prev, ...mappedItems];
        return appended.map((row, idx) => ({ ...row, slNo: idx + 1 }));
      });
    }

    setShowInvoiceModal(false);
  };
  const handleQtyChange = (index, value) => {
    const updatedItems = [...items];

    if (value === "") {
      updatedItems[index].qty = "";
      setItems(updatedItems);
      return;
    }

    let enteredQty = Number(value);

    if (enteredQty < 0 || isNaN(enteredQty)) {
      enteredQty = 1;
    }

    updatedItems[index].qty = enteredQty;
    setItems(updatedItems);
  };
  const fetchDepartments = async () => {
    try {
      const apiURL = `${BASE_URL}/api/CpaysCount/${COMPANY_CODE}/DEPTLIST/-/-`;
      const response = await axios.get(apiURL);
      const data = response.data;
      setDepartmentList(data);
    } catch (error) {
      console.error("Error while fetching Dept list!", error);
    }
  };
  const fetchGlSettings = async () => {
    try {
      const apiURL = `${BASE_URL}/api/CRMGLSettings/${COMPANY_CODE}/Scrn_code/CM/-/${selectedDept}/-`;
      const response = await axios.get(apiURL);
      const data = response.data;

      const mapped = {
        credit: data.find((item) => item.Scrn_code === "CM-STK-C") || {},
        debit: data.find((item) => item.Scrn_code === "CM-STK-D") || {},
      };

      setGlSettings(mapped);
    } catch (error) {
      console.error("Error while fetching gl settings", error);
    }
  };
  const fetchClaimNumber = async () => {
    try {
      const url = `${BASE_URL}/api/CRMVoucherSettings/${COMPANY_CODE}/VOUCHERNUMBERS/${DEPARTMENT}/GET/CM/-`;

      const response = await axios.get(url);

      if (response.data && response.data.length > 0) {
        const nextNo = response.data[0]?.NEXT_NO;

        setClaimNo(nextNo);

        console.log("Claim Number:", nextNo);
      }
    } catch (error) {
      console.error("Error fetching Claim Number:", error);
    }
  };
  useEffect(() => {
    fetchDepartments();

    if (isEditMode || isViewMode) {
      fetchClaimDetails(); // EDIT / VIEW
    } else {
      fetchClaimNumber(); // SAVE
      fetchGlSettings();
    }
  }, []);

  const calculateAgedDays = (dateStr) => {
    if (!dateStr || dateStr === "-") return 0;
    const diffTime = Math.abs(new Date() - new Date(dateStr));
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  };
  const fetchProductData = useCallback(
    async (query, searchByValue, location = "A") => {
      const effectiveQuery = query?.trim() === "" ? "-" : query?.trim() || "-";
      const formattedQuery = effectiveQuery.replace(/\//g, "%2F");

      try {
        if (!loading) setLoading(true);
        const url = `${BASE_URL}/api/CRMStockList/${COMPANY_CODE}/${searchByValue}/${formattedQuery}/${location}/-`;
        const response = await request({
          url: url,
          method: "GET",
          timeout: 5000,
        });
        if (response) {
          setProducts(response);
        } else {
          setProducts([]);
        }
      } catch (err) {
        console.error("Failed to fetch product data", err);
        setProducts([]);
      } finally {
        setLoading(false);
      }
    },
    [BASE_URL, COMPANY_CODE],
  );
  useEffect(() => {
    if (!searchQuery && searchBy === "UNIVERSAL") return;
    fetchProductData(searchQuery, searchBy);
  }, [searchQuery, searchBy, fetchProductData]);

  const handleProductSelect = (product) => {
    console.log(" Selected Product from Stock List:", product);

    if (activeRowIndex !== null) {
      const updatedItems = [...items];

      // Update the row with the selected product data
      updatedItems[activeRowIndex] = {
        ...updatedItems[activeRowIndex],
        // Check your console log to see which of these keys exists in your object
        replCode:
          product.Code || product.code || product.CODE || product.PROCODE,
        rplPrice: product.unit_price || product.PRICE || 0,
      };

      setItems(updatedItems);
    }

    setShowStockList(false);
    setActiveRowIndex(null);
  };
  const handleCustomerSelect = (selectedCustomer) => {
    console.log("Selected Supplier for Row:", activeRowIndex, selectedCustomer);

    if (activeRowIndex !== null) {
      const updatedItems = [...items];

      // Update only the specific row in the table
      updatedItems[activeRowIndex] = {
        ...updatedItems[activeRowIndex],
        supplierAcc: selectedCustomer.ACCOUNT,
        supplier: selectedCustomer.DESCRIPTION?.trim(),
      };

      setItems(updatedItems);
    }

    setShowCustomerList(false);
    setActiveRowIndex(null);
  };
  const fetchClaimDetails = async () => {
    try {
      const url = `${BASE_URL}/api/DocumentEditDetails/${COMPANY_CODE}/CLAIM/${documentNoFromState}/${DEPARTMENT}`;
      const response = await axios.get(url);
      if (response.data && response.data.length > 0) {
        const data = response.data;
        const firstRow = data[0];
        setClaimNo(firstRow.claimno);
        setInvoice({
          INVNO: firstRow.InvoiceNo,
        });
        setCustomer({
          account: firstRow.Account,
          name: firstRow.Accdesc,
          phone: firstRow.contactNo,
          invDate: firstRow.SalesDate,
        });
        setGlSettings({
          debit: {
            ACCOUNT: firstRow.DrAc,
            accdesc: firstRow.DrAcdesc,
          },
          credit: {
            ACCOUNT: firstRow.CrAc,
            accdesc: firstRow.CrAcdesc,
          },
        });
        setRemarks(firstRow.Remarks || firstRow.remarks || "");
        const mappedItems = data.map((row, index) => ({
          slNo: index + 1,
          code: row.code,
          description: row.idesc,
          qty: Number(row.tr_qty),
          maxQty: Number(row.tr_qty),
          replCode: row.Repl_Code,
          replSerial: row.wnno,
          c1: row.complaint1,
          c2: row.complaint2,
          rcvdSerial: row.repl_serial,
          supplierAcc: row.suppacc,
          supplier: row.suppdesc,
          rtnPrice: Number(row.amount || 0),
          rplPrice: Number(row.Rpl_Price),
          it_slno: "",
        }));

        setItems(mappedItems);
      }
    } catch (error) {
      console.error("Error fetching Claim Details:", error);
    }
  };
  const calculateTotals = () => {
    let returnedValue = 0;
    let replacedValue = 0;

    items.forEach((row) => {
      const qty = Number(row.qty) || 0;
      const rtnPrice = Number(row.rtnPrice) || 0;
      const rplPrice = Number(row.rplPrice) || 0;

      returnedValue += qty * rtnPrice;
      replacedValue += qty * rplPrice;
    });

    const differenceAmount = replacedValue - returnedValue;

    const vatAmount = (differenceAmount * (Number(vatPercent) || 0)) / 100;

    const netAmount = differenceAmount + vatAmount;

    return {
      returnedValue,
      replacedValue,
      differenceAmount,
      vatAmount,
      netAmount,
    };
  };
  const totals = calculateTotals();
  const buildPayload = () => {
    const claimDate = new Date().toISOString();

    const payload = items.map((row, index) => ({
      CmpCode: COMPANY_CODE,
      mode: mode,
      ClaimNo: String(claimNo),
      ClaimDate: claimDate,
      InvoiceNo: invoice?.INVNO || "",
      SalesDate: customer?.invDate
        ? new Date(customer.invDate).toISOString()
        : null,
      DaysCovered: calculateAgedDays(customer?.invDate),
      Account: customer?.account || "",
      Accdesc: customer?.name || "",
      Salesman: CURRENT_USER_OBJECT[0].sales_man,
      User: CURRENT_USER_OBJECT[0].user,
      Remarks: remarks || "Product warranty claim",
      deptno: DEPARTMENT,
      contactPerson: customer?.name || "",
      contactNo: customer?.phone || "",
      DrAc: glSettings?.debit?.ACCOUNT || "",
      DrAcdesc: glSettings?.debit?.accdesc || "",
      CrAc: glSettings?.credit?.ACCOUNT || "",
      CrAcdesc: glSettings?.credit?.accdesc || "",
      amount: String(row.rtnPrice || 0),
      VAT: String(totals.vatAmount || 0),
      netamount: String(totals.netAmount || 0),
      code: row.code || "",
      idesc: row.description || "",
      tr_qty: row.qty || 0,
      complaint1: row.c1 || "",
      complaint2: row.c2 || "",
      complaint3: "",
      complaint4: "",
      complaint5: "",
      complaint6: "",
      complaint7: "",
      complaint8: "",
      complaint9: "",
      complaint10: "",
      wnno: row.replSerial || "", //REPL Serial
      suppacc: row.supplierAcc || "",
      suppdesc: row.supplier || "",
      it_slno: "",
      Repl_Code: row.replCode || "", //REPL Code
      repl_serial: row.rcvdSerial || "", //RCVD Serial
      Rpl_Price: row.rplPrice || "", //RPL Price
    }));

    return payload;
  };
  const handleSave = async () => {
    if (!invoice?.INVNO) {
      alert("Select Invoice");
      return;
    }

    if (items.length === 0) {
      alert("Add at least one item");
      return;
    }
    try {
      const payload = buildPayload();
      console.log("Payload:", payload);
      const response = await axios.post(`${BASE_URL}/api/ClaimRegCRM`, payload);
      console.log("Save Success:", response.data);
      alert(`Warranty Claim Saved ${response.data.claimNo} Successfully`);
      navigate("/warranty_claim_list");
    } catch (error) {
      console.error("Save Failed:", error);
      alert("Error saving warranty claim ");
    }
  };
  return (
    <div className="p-2">
      <header className="bg-white rounded-xl shadow-sm border border-slate-200 px-5 py-3 mb-4 flex justify-between items-center">
        <div className="flex items-center gap-3">
          <h1 className="text-base font-bold text-slate-900">
            Warranty Claim
            <span className="text-indigo-600 ml-1">#{claimNo}</span>
            {isEditMode && (
              <span className="ml-2 text-xs bg-yellow-100 text-yellow-700 px-2 py-0.5 rounded">
                EDIT MODE
              </span>
            )}
            {isViewMode && (
              <span className="ml-2 text-xs bg-slate-200 text-slate-700 px-2 py-0.5 rounded">
                VIEW MODE
              </span>
            )}
          </h1>
        </div>
        <div className="flex items-center gap-2">
          <button className="px-4 py-1.5 rounded-lg border border-slate-200 text-slate-600 font-bold text-[11px] hover:bg-slate-50 transition">
            View Records
          </button>
          <button
            onClick={handleSave}
            disabled={isViewMode}
            className="bg-indigo-600 text-white px-5 py-1.5 rounded-lg font-bold text-[11px] shadow-md hover:bg-indigo-700 transition flex items-center gap-2"
          >
            <Save size={14} /> Save Record
          </button>
        </div>
      </header>

      <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-5 mb-4">
        <div className="grid grid-cols-12 gap-x-8 gap-y-5">
          {/* Section 1: Claim Essentials */}
          <div className="col-span-3 border-r border-slate-100 pr-6 space-y-4">
            <div>
              <label className="text-[10px] font-semibold text-slate-400 uppercase block mb-1">
                Claim No & Date
              </label>
              <div className="flex items-center justify-between gap-2">
                <span className="text-xs font-bold text-slate-800">
                  #{claimNo}
                </span>
                <input
                  type="date"
                  className="text-xs font-bold border-slate-200 outline-none w-28"
                  defaultValue="2026-03-18"
                />
              </div>
            </div>
            <div>
              <label className="text-[10px] font-semibold text-slate-400 uppercase block mb-2">
                Transaction Type
              </label>
              <div className="flex bg-slate-100 p-1 rounded-lg w-full">
                {["Invoice", "Claim"].map((t) => (
                  <button
                    key={t}
                    onClick={() => setIsLocal(t === "Invoice")}
                    className={`flex-1 py-1 text-[9px] font-semibold rounded-md uppercase transition-all ${(isLocal && t === "Invoice") || (!isLocal && t === "Claim") ? "bg-white shadow-sm text-indigo-600" : "text-slate-400"}`}
                  >
                    {t}
                  </button>
                ))}
              </div>
            </div>
          </div>

          {/* Section 2: Department & Reference */}
          <div className="col-span-3 border-r border-slate-100 pr-6 space-y-4">
            <div>
              <label className="text-[10px] font-semibold text-slate-400 uppercase block mb-1">
                Department
              </label>
              <select
                value={selectedDept}
                onChange={(e) => setSelectedDept(e.target.value)}
                className="w-full text-xs font-bold border-b border-slate-200 py-1 bg-transparent outline-none"
              >
                {departmentList?.map((dept) => (
                  <option
                    key={dept.deptno}
                    value={dept.deptno}
                    className="flex items-center justify-between"
                  >
                    {dept.deptnodesc} - {dept.deptno.trim()}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label className="text-[10px] font-semibold text-slate-400 uppercase block mb-1">
                Inv No / Search
              </label>
              <div className="flex items-center gap-2">
                <div className="relative flex-1">
                  <input
                    ref={invoiceInputRef}
                    type="text"
                    placeholder="Find Invoice... (F2)"
                    className="w-full text-xs font-bold border-b border-slate-200 py-1 pl-6 outline-none focus:border-indigo-500"
                    value={invoice?.INVNO || ""}
                    onChange={(e) =>
                      setInvoice({ ...invoice, INVNO: e.target.value })
                    }
                  />
                  <Search
                    className="absolute left-0 bottom-1.5 text-slate-400"
                    size={14}
                  />
                </div>
                <button
                  className="bg-slate-900 text-white p-1 rounded-md hover:bg-slate-800"
                  onClick={() => setShowInvoiceModal(true)}
                >
                  <ArrowRight size={14} />
                </button>
              </div>
            </div>
          </div>

          {/* Section 3: Customer & Contact (Improved Layout) */}
          <div className="col-span-3 border-r border-slate-100 pr-6">
            {customer ? (
              <div className="flex flex-col justify-between">
                {/* Header */}
                <div className="flex justify-between items-center mb-2">
                  <label className="text-[10px] font-semibold text-slate-400 uppercase">
                    Customer & Invoice Details
                  </label>

                  <span className="text-[9px] font-bold text-orange-600 bg-orange-50 px-2 py-0.5 rounded border border-orange-100 uppercase">
                    {calculateAgedDays(customer?.invDate)} Days
                  </span>
                </div>

                <div className="flex items-center justify-between gap-4">
                  {/* Left Side: Account & Description */}
                  <div className="flex flex-col justify-start items-start min-w-0 flex-1">
                    <span className="text-[11px] font-bold text-indigo-600 whitespace-nowrap">
                      {customer.account}
                    </span>

                    <p className="text-xs font-semibold text-slate-700 truncate uppercase tracking-tight">
                      {customer.name}
                    </p>
                  </div>

                  {/* Right Side: Invoice Date Section */}
                  <div className="flex flex-col items-end shrink-0">
                    <span className="text-[10px] font-bold text-slate-400 uppercase leading-none mb-1">
                      Invoice Date
                    </span>
                    <p className="text-[11px] font-bold text-slate-800 tabular-nums leading-none">
                      {customer.invDate
                        ? new Date(customer.invDate).toLocaleDateString("en-GB")
                        : "--/--/----"}
                    </p>
                  </div>
                </div>

                {/* Added: Remarks Field */}
                <div className=" mt-2">
                  <div className="flex flex-col gap-1">
                    <label className="text-[9px] font-bold text-slate-400 uppercase">
                      Remarks
                    </label>
                    <input
                      type="text"
                      placeholder="Add internal notes..."
                      className="w-full bg-slate-50/50 border border-slate-200 rounded outline-none px-2 py-1 text-[10px] font-medium text-slate-600 focus:outline-none focus:ring-1 focus:ring-indigo-500/20 focus:border-indigo-300 placeholder:text-slate-300 transition-all"
                      value={remarks || ""}
                      onChange={(e) => {
                        setRemarks(e.target.value);
                      }}
                    />
                  </div>
                </div>
              </div>
            ) : (
              <div className="h-full flex flex-col items-center justify-center border-2 border-dashed border-slate-100 rounded-xl bg-slate-50/50 p-4">
                <div className="w-8 h-8 rounded-full bg-slate-100 flex items-center justify-center mb-2">
                  <Search size={16} className="text-slate-400" />
                </div>

                <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest text-center">
                  No Customer Found
                </p>
              </div>
            )}
          </div>

          {/* Section 4: Ledgers */}
          <div className="col-span-3 space-y-2">
            <label className="text-[10px] font-semibold text-slate-400 uppercase block">
              Accounting Ledgers
            </label>

            <div className="bg-slate-50 border border-slate-100 rounded-lg px-3 py-2 space-y-2">
              {/* Debit Row */}
              <div className="flex items-center justify-between gap-2">
                <div className="flex items-center gap-2 min-w-0">
                  <span className="text-[10px] font-semibold text-blue-500 uppercase">
                    Dr
                  </span>

                  <p className="text-[10px] font-bold text-slate-700 truncate">
                    {glSettings.debit?.accdesc || "---"}
                  </p>
                </div>

                <span className="text-[10px] font-bold text-blue-600 bg-blue-50 px-2 py-0.5 rounded border border-blue-100 whitespace-nowrap">
                  #{glSettings.debit?.ACCOUNT || "----"}
                </span>
              </div>

              {/* Credit Row */}
              <div className="flex items-center justify-between gap-2">
                <div className="flex items-center gap-2 min-w-0">
                  <span className="text-[10px] font-semibold text-red-500 uppercase">
                    Cr
                  </span>

                  <p className="text-[10px] font-bold text-slate-700 truncate">
                    {glSettings.credit?.accdesc || "---"}
                  </p>
                </div>

                <span className="text-[10px] font-bold text-red-500 bg-red-50 px-2 py-0.5 rounded border border-red-100 whitespace-nowrap">
                  #{glSettings.credit?.ACCOUNT || "----"}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-5 gap-4 mb-4">
        {[
          {
            label: "Returned Value",
            val: totals.returnedValue.toFixed(2),
            bg: "bg-white",
          },
          {
            label: "Difference Amount",
            val: totals.differenceAmount.toFixed(2),
            bg: "bg-white",
            text: "text-orange-600",
          },
          {
            label: "Replaced Value",
            val: totals.replacedValue.toFixed(2),
            bg: "bg-white",
          },
          {
            label: "VAT Amount",
            val: totals.vatAmount.toFixed(2),
            bg: "bg-white",
            text: "text-red-500",
          },
          {
            label: "Net Amount",
            val: totals.netAmount.toFixed(2),
            bg: "bg-indigo-600",
            text: "text-white",
          },
        ].map((item, i) => (
          <div
            key={i}
            className={`${item.bg} border border-slate-200 rounded-xl p-3 flex flex-col shadow-sm`}
          >
            <span
              className={`text-[9px] font-semibold uppercase tracking-wider ${item.text && item.bg !== "bg-indigo-600" ? item.text : "text-slate-400"} ${item.bg === "bg-indigo-600" ? "text-indigo-200" : ""}`}
            >
              {item.label}
            </span>

            <span
              className={`text-sm font-semibold ${item.text || "text-slate-800"}`}
            >
              {item.val}
            </span>
          </div>
        ))}
      </div>

      {/* TABLE SECTION */}
      <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden flex-1">
        <div className="px-5 py-3 border-b border-slate-100 flex justify-between items-center">
          <h2 className="text-[11px] font-semibold text-slate-700 uppercase tracking-widest flex items-center gap-2">
            <FileText size={14} className="text-indigo-600" /> Claim Line Items
            ({items.length})
          </h2>
          <button
            onClick={() => setItems([...items, { slNo: items.length + 1 }])}
            className="text-[10px] font-semibold bg-indigo-50 text-indigo-600 px-3 py-1.5 rounded-lg border border-indigo-100 hover:bg-indigo-100"
          >
            + ADD NEW ROW
          </button>
        </div>

        <div className="overflow-x-auto max-h-[400px]">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-slate-50/50">
                {[
                  "Slno",
                  "Code",
                  "Description",
                  "Qty",
                  "Repl_Code",
                  "Repl_Serial",
                  "C1",
                  "C2",
                  "Rcvd_Serial",
                  "SupplierAcc",
                  "Supplier",
                  "Rtn_Price",

                  "Rpl_Price",
                  "Action",
                ].map((header, i) => (
                  <th
                    key={i}
                    className={`px-3 py-3 text-[9px] font-semibold text-slate-400 uppercase border-b border-slate-200 text-left whitespace-nowrap ${i === 0 ? "sticky left-0 bg-slate-50 z-20 shadow-[1px_0_0_#e2e8f0]" : ""}`}
                  >
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="text-[11px]">
              {items.map((row, idx) => (
                <tr key={idx} className="hover:bg-slate-50/50">
                  <td className="px-3 py-2 sticky left-0 bg-white z-10 border-b border-slate-100 font-bold text-slate-400 text-center shadow-[1px_0_0_#f1f5f9]">
                    {row.slNo}
                  </td>
                  <td className="px-3 py-2 border-b border-slate-100 font-bold text-indigo-600">
                    {row.code}
                  </td>
                  <td className="px-3 py-2 border-b border-slate-100 font-bold text-slate-700 min-w-[200px]">
                    {row.description}
                  </td>
                  <td className="px-3 py-2 border-b border-slate-100 text-center font-semibold">
                    {/* {row.qty} */}
                    <input
                      type="number"
                      min="0"
                      max={1}
                      disabled={isViewMode}
                      readOnly
                      className="w-14 px-2 py-1 border border-slate-100 rounded text-[10px] focus:border-indigo-500 bg-indigo-50/30"
                      value={1}
                      // onChange={(e) => handleQtyChange(idx, e.target.value)}
                    />
                  </td>
                  <td className="px-1 py-1 border-b border-slate-100">
                    <input
                      className="w-20 px-2 py-1 border border-slate-100 rounded text-[10px] focus:border-indigo-500 bg-indigo-50/30"
                      placeholder="Select Code"
                      value={row.replCode || ""}
                      readOnly
                      // onClick={() => {
                      //   setActiveRowIndex(idx);
                      //   setShowStockList(true);
                      // }}
                      onKeyDown={(e) => {
                        if (e.key === "F2") {
                          e.preventDefault(); // Prevent any default browser behavior
                          setActiveRowIndex(idx);
                          setShowStockList(true);
                        }
                      }}
                    />
                  </td>
                  <td className="px-1 py-1 border-b border-slate-100">
                    <input
                      className="w-20 px-2 py-1 border border-slate-100 rounded text-[10px]"
                      value={row.replSerial || ""}
                      onChange={(e) => {
                        const updatedItems = [...items];
                        updatedItems[idx].replSerial = e.target.value;
                        setItems(updatedItems);
                      }}
                    />
                  </td>
                  <td className="px-1 py-1 border-b border-slate-100">
                    <input
                      onChange={(e) => {
                        const updatedItems = [...items];
                        updatedItems[idx].c1 = e.target.value;
                        setItems(updatedItems);
                      }}
                      value={row.c1 || ""}
                      className="w-24 px-1 py-1 border border-slate-100 rounded text-[10px]"
                    />
                  </td>
                  <td className="px-1 py-1 border-b border-slate-100">
                    <input
                      className="w-24 px-1 py-1 border border-slate-100 rounded text-[10px]"
                      value={row.c2 || ""}
                      onChange={(e) => {
                        const updatedItems = [...items];
                        updatedItems[idx].c2 = e.target.value;
                        setItems(updatedItems);
                      }}
                    />
                  </td>
                  <td className="px-1 py-1 border-b border-slate-100">
                    <input
                      className="w-24 px-2 py-1 border border-slate-100 rounded text-[10px]"
                      defaultValue={row.rcvdSerial}
                      onChange={(e) => {
                        const updatedItems = [...items];
                        updatedItems[idx].rcvdSerial = e.target.value;
                        setItems(updatedItems);
                      }}
                    />
                  </td>
                  <td className="px-3 py-2 border-b border-slate-100 text-slate-400 uppercase font-bold">
                    {/* {row.supplierAcc} */}
                    <input
                      className="w-20 px-2 py-1 border border-slate-100 rounded text-[10px] focus:border-indigo-400 outline-none"
                      /* CRITICAL: Use row data, not the global customer state */
                      value={row.supplierAcc || ""}
                      readOnly
                      onClick={() => {
                        setActiveRowIndex(idx);
                        setShowCustomerList(true);
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "F2") {
                          e.preventDefault();
                          setActiveRowIndex(idx);
                          setShowCustomerList(true);
                        }
                      }}
                    />
                  </td>
                  <td className="px-3 py-2 border-b border-slate-100">
                    <input
                      className="w-20 px-2 py-1 border border-slate-100 rounded text-[10px] bg-slate-50"
                      value={row.supplier || ""}
                      readOnly
                    />
                  </td>
                  {/* <td className="px-3 py-2 border-b border-slate-100 font-semibold text-indigo-600">
                    {row.rtnPrice}
                  </td> */}
                  <td className="px-1 py-1 border-b border-slate-100">
                    <input
                      type="number"
                      className="w-20 px-2 py-1 border border-slate-100 rounded text-[10px]"
                      value={row.rtnPrice || ""}
                      onChange={(e) => {
                        const updatedItems = [...items];
                        updatedItems[idx].rtnPrice = e.target.value;
                        setItems(updatedItems);
                      }}
                    />
                  </td>
                  {/* <td className="px-3 py-2 border-b border-slate-100 text-slate-400 font-bold">
                    {row.itSlNo}
                  </td> */}
                  {/* <td className="px-3 py-2 border-b border-slate-100 text-slate-400 font-bold truncate max-w-[50px]">
                    {row.gid}
                  </td> */}
                  {/* <td className="px-3 py-2 border-b border-slate-100 font-semibold text-slate-800">
                    {row.rplPrice}
                  </td> */}
                  <td className="px-1 py-1 border-b border-slate-100">
                    <input
                      className="w-20 px-2 py-1 border border-slate-100 rounded text-[10px]"
                      value={row.rplPrice || ""}
                      onChange={(e) => {
                        const updatedItems = [...items];
                        updatedItems[idx].rplPrice = e.target.value;
                        setItems(updatedItems);
                      }}
                    />
                  </td>
                  <td className="px-3 py-2 border-b border-slate-100">
                    <button
                      onClick={() =>
                        setItems(
                          items
                            .filter((_, i) => i !== idx)
                            .map((row, i) => ({ ...row, slNo: i + 1 })),
                        )
                      }
                      className="text-slate-300 hover:text-red-500 transition"
                    >
                      <Trash2 size={14} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <Modal
        isOpen={showInvoiceModal}
        onClose={() => setShowInvoiceModal(false)}
        title="Select Invoice"
        size="xxl"
      >
        <TransferInvoiceListModal
          onPickItems={(invNo, items) => {
            const invRow = { INVNO: invNo };
            handleInvoiceSelect(invRow, items);
          }}
          setIsModalOpen={setShowInvoiceModal}
          initialSearchQuery={invoice?.INVNO || ""}
        />
      </Modal>
      <Modal
        isOpen={showStockList}
        onClose={() => setShowStockList(false)}
        title="Stock List"
        size="xxl"
      >
        <ProductListing
          modalSuggestions={products}
          loading={loading}
          searchBy={searchBy}
          setSearchBy={setSearchBy}
          onSearchQueryChange={setSearchQuery}
          handleProductSelect={handleProductSelect}
        />
      </Modal>
      <Modal
        isOpen={showCustomerList}
        onClose={() => setShowCustomerList(false)}
        title="Customer List"
        size="xxl"
      >
        <CreditCustomerList
          handleCustomerSelect={handleCustomerSelect}
          defaultType="Suppliers"
        />
      </Modal>
    </div>
  );
};

export default WarrantyClaim;
